<div class="relative">
  <ng-container *ngIf="host === 'entry'; else viewTemplate">
    <uni-image
      [src]="blog.image"
      [default]="defaultImage"
      [alt]="blog.title" 
      [classes]="'rounded-border fit-cover sparro-bg-grey-100 '
        +(featured ? 'blog-card-image-featured' : 'blog-card-image')">
    </uni-image>
    <!-- TODO: Entry host cannot really be featured, right? So maybe simplify the above condn -->
  </ng-container>

  <ng-template #viewTemplate>
    <ng-container *ngIf="blog.slug; else editView">
      <a [href]="getBlogDetailLink()" target="_blank" class="no-decor pointer">
        <ng-container *ngTemplateOutlet="detailView">
        </ng-container>
      </a>
    </ng-container>
    <ng-template #editView>
      <a [href]="getBlogDetailLink()" class="no-decor pointer">
        <ng-container *ngTemplateOutlet="detailView">
        </ng-container>
      </a>
    </ng-template>
  </ng-template>
</div>

<ng-template #detailView>
  <uni-image
    [src]="blog.image"
    [default]="defaultImage"
    [alt]="blog.title"
    [width]="(featured && cardWidth >= 541) ? 680 : 680"
    [height]="(featured && cardWidth >= 541) ? 510 : 510"
    [classes]="'rounded-border fit-cover sparro-bg-grey-100 '
        +(featured ? 'blog-card-image-featured' : ( 'blog-card-image' +
          (cardWidth <= 361 ? '-sm' : (cardWidth <= 541 ? '-md' : ''))
          ))">
  </uni-image>
  <section class="absolute right-2 bottom-3" *ngIf="hasImageBadge && cardWidth>540">
    <div fxLayoutAlign="start center" fxLayoutGap="8px">
      <div
        class="blog-badge"
        [ngClass]="{'blog-badge-featured': featured }"
        *ngIf="blog.likes">
        <i class="icon-like font-sm fx-contents badge-icon"></i>
        <span class="font-xxs padding-x-4 badge-text">{{ blog.likes }}</span>
      </div>
      <div
        class="blog-badge"
        [ngClass]="{'blog-badge-featured': featured }"
        *ngIf="blog.comments">
        <i class="icon-comments font-sm fx-contents badge-icon"></i>
        <span class="font-xxs padding-x-4 badge-text">{{ blog.comments }}</span>
      </div>
    </div>
  </section>
</ng-template>
